import gql from 'graphql-tag';

export { 
  createOrg, 
  updateOrg,
  createUnit, 
  updateUnit,
  createQuestionTemplate,
  updateQuestionTemplate,
  deleteQuestionTemplate,
  createSectionTemplate,
  updateSectionTemplate,
  deleteSectionTemplate,
  createFormTemplate,
  updateFormTemplate,
  deleteFormTemplate,
  createFormAnswer,
  updateFormAnswer,
  createUnitTestConfig,
  updateUnitTestConfig,
  createFormSubscriber,
  updateFormSubscriber,
  deleteFormTemplateActivity,
  createFormTemplateActivity,
  createQuestionTemplateActivity,
  createInventory,
  updateInventory,
  deleteInventory,
  createOrgInventory,
  updateOrgInventory,
  restockInventory,
  updateInventoryStock,
  allocateInventoryToDevice,
  updateInventoryBatch,
  upsertTestInventoryConfig,
  deleteTestInventoryConfig,
  updateInventoryOnTestCompleteV2,
  updateOrderSet,
  createOrderSet,
  deleteOrderSet,
  cloneFormTemplate,
  createStaff
}

const inventoryBatchMutationFields = `
  id
  typeValue
  code
  itemCode
  itemName
  unit
  batchNumber
  expiryDate
  orgId
  unitId
  deviceId
  scope
  unitsPerPack
  totalStock
  currentStock
  availablePacks
  createdAt
  updatedAt
  createdBy
  updatedBy
`;

const inventoryActivityFields = `
  id
  typeValue
  code
  orgId
  unitId
  deviceId
  itemCode
  itemName
  qty
  consumedBy
  note
  batchNumber
  expiryDate
  packCount
  unitsPerPack
  type
  createdAt
  createdBy
`;

const inventoryMutationFields = `
  success
  message
  inventory {
    id
    typeValue
    code
    name
    unit
    description
    orgId
    unitId
    deviceId
    scope
    totalStock
    currentStock
    consumedStock
    adjustedStock
    allocatedStock
    lowStockThreshold
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
  inventories {
    id
    typeValue
    code
    name
    unit
    description
    orgId
    unitId
    deviceId
    scope
    totalStock
    currentStock
    consumedStock
    adjustedStock
    allocatedStock
    lowStockThreshold
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
  batch {
    ${inventoryBatchMutationFields}
  }
  batches {
    ${inventoryBatchMutationFields}
  }
  activities {
    ${inventoryActivityFields}
  }
  insufficientStock {
    code
    name
    requiredStock
    availableStock
    scope
    orgId
    unitId
    deviceId
  }
`;

const createOrgInventory = gql`
mutation createOrgInventory($input: CreateOrgInventoryInput!){
  createOrgInventory(input: $input){
    ${inventoryMutationFields}
  }
}
`;

const updateOrgInventory = gql`
mutation updateOrgInventory($input: UpdateOrgInventoryInput!){
  updateOrgInventory(input: $input){
    ${inventoryMutationFields}
  }
}
`;

const restockInventory = gql`
mutation restockInventory($input: RestockInventoryInput!){
  restockInventory(input: $input){
    ${inventoryMutationFields}
  }
}
`;

const updateInventoryStock = gql`
mutation updateInventoryStock($input: UpdateInventoryStockInput!){
  updateInventoryStock(input: $input){
    ${inventoryMutationFields}
  }
}
`;

const allocateInventoryToDevice = gql`
mutation allocateInventoryToDevice($input: AllocateInventoryToDeviceInput!){
  allocateInventoryToDevice(input: $input){
    ${inventoryMutationFields}
  }
}
`;

const updateInventoryBatch = gql`
mutation updateInventoryBatch($input: UpdateInventoryBatchInput!){
  updateInventoryBatch(input: $input){
    ${inventoryMutationFields}
  }
}
`;

const upsertTestInventoryConfig = gql`
mutation upsertTestInventoryConfig($input: UpsertTestInventoryConfigInput!){
  upsertTestInventoryConfig(input: $input){
    ${inventoryMutationFields}
  }
}
`;

const deleteTestInventoryConfig = gql`
mutation deleteTestInventoryConfig($input: DeleteTestInventoryConfigInput!){
  deleteTestInventoryConfig(input: $input){
    ${inventoryMutationFields}
  }
}
`;

const updateInventoryOnTestCompleteV2 = gql`
mutation updateInventoryOnTestCompleteV2($input: UpdateInventoryOnTestCompleteV2Input!){
  updateInventoryOnTestCompleteV2(input: $input){
    ${inventoryMutationFields}
  }
}
`;



const cloneFormTemplate = gql`
  mutation cloneFormTemplate($input: CloneFormTemplateInput! ){
    cloneFormTemplate(input: $input){
      # id
    uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      # uId
      attachedQuestionRefs {
        id
        typeValue
        slugValue
        questionTitle
        questionType
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
    }
  }
`;

const deleteOrderSet = gql`
mutation deleteOrderSet( $slugValue: String! $typeValue: String!){
  deleteOrderSet(slugValue: $slugValue typeValue: $typeValue){
    id
    typeValue
    slugValue
    orderSetName
  }
}
# {
#   "typeValue": "global",
#   "slugValue": "fever-as::g4"
# }
`;

const createOrderSet = gql`
mutation createOrderSet(
    $typeValue: String!
    $slugValue: String!
    $orderSetName: String!
    $searchField: String!
    $diagnosis: String!
    $advice: [String!]
    $medication: [MedicationInput!]
    $procedure: [String!]
    $investigation: [String!]
    $note: String
    $active: Boolean
    $appliedFor: String
    $ageGroup: [AgeGroupInput!]
){
  createOrderSet(input:{
    typeValue: $typeValue
    slugValue: $slugValue
    orderSetName: $orderSetName
    searchField: $searchField
    diagnosis: $diagnosis
    advice: $advice
    medication: $medication
    procedure: $procedure
    investigation: $investigation
    note: $note
    active: $active
    appliedFor: $appliedFor
    ageGroup: $ageGroup
  }){
    id
    typeValue
    slugValue
    orderSetName
    searchField
    diagnosis
    advice
    procedure
    investigation
    note
    active 
    ageGroup{
        ageFrom
        ageTo
    } 
    medication{
      brandName
      genericName
      frequency
      dosage
      dosageUnit
      dosageDate
      roa
      instruction
    }
    investigationMap{
        serviceCode
        serviceName
      }
      procedureMap{
        serviceCode
        serviceName
      }
      adviceMap{
        slugValue
        adviceName
      }
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
}
# {
#   "typeValue": "global",
#   "slugValue": "fever-as::a3",
#   "orderSetName": "Fever as",
#   "searchField": "fever as",
#   "diagnosis": "a3",
#   "advice": ["rest"],
#   "procedure": ["proc1","fe"],
#   "investigation": ["dsd"],
#   "note": "testing",
#   "medication": {
#     "brandName": "cipla",
#     "genericName": "Cipla tab",
#     "frequency": "2",
#     "dosage": "4",
#     "dosageUnit": "mg",
#     "dosageDate": "12-12-2020",
#     "roa": "oral",
#     "instruction": "fedf"
#   }
# }
`;


const updateOrderSet = gql`
mutation updateOrderSet(
    $typeValue: String!
    $slugValue: String!
    $orderSetName: String!
    $searchField: String!
    $diagnosis: String!
    $advice: [String!]
    $medication: [MedicationInput!]
    $procedure: [String!]
    $investigation: [String!]
    $note: String
    $active: Boolean
    $appliedFor: String
    $ageGroup: [AgeGroupInput!]
){
  updateOrderSet(input:{
    typeValue: $typeValue
    slugValue: $slugValue
    orderSetName: $orderSetName
    searchField: $searchField
    diagnosis: $diagnosis
    advice: $advice
    medication: $medication
    procedure: $procedure
    investigation: $investigation
    note: $note
    active: $active
    appliedFor: $appliedFor
    ageGroup: $ageGroup
  }){
    id
    typeValue
    slugValue
    orderSetName
    searchField
    diagnosis
    advice
    procedure
    investigation
    note
    active
    ageGroup{
        ageFrom
        ageTo
    } 
    medication{
      brandName
      genericName
      frequency
      dosage
      dosageUnit
      dosageDate
      roa
      instruction
    }
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
}
# {
#   "typeValue": "global",
#   "slugValue": "fever-as::a3",
#   "orderSetName": "Fever as",
#   "searchField": "fever as",
#   "diagnosis": "a3",
#   "advice": ["rest","exercise"],
#   "procedure": ["proc1","fe"],
#   "investigation": ["dsd"],
#   "note": "testing",
#   "medication": {
#     "brandName": "cipla",
#     "genericName": "Cipla tab",
#     "frequency": "2",
#     "dosage": "4",
#     "dosageUnit": "mg",
#     "dosageDate": "12-12-2020",
#     "roa": "oral",
#     "instruction": "fedf"
#   }
# }
`
const deleteInventory = gql`
mutation deleteInventory($typeValue: String! $code: String!){
  deleteInventory(typeValue: $typeValue code: $code){
    typeValue
    code
    name
  }
}
# {
#   "typeValue": "global",
#   "code": "c2"
# }
`


const updateInventory = gql`
mutation updateInventory(
  	$typeValue: String!
    $code: String!
    $name: String
    $description: String
    $totalStock: Int
    $currentStock: Int
    $consumedStock: Int
    $adjustedStock: Int
){
  updateInventory(input:{
    typeValue: $typeValue
    code: $code
    name: $name
    description: $description
    totalStock: $totalStock
    currentStock: $currentStock
    consumedStock: $consumedStock
    adjustedStock: $adjustedStock
  }){
    id
    typeValue
    code
    name
    description
    totalStock
    currentStock
    consumedStock
    adjustedStock
    createdAt
    updatedAt
    updatedBy
  }
}
# {
#   "typeValue": "global",
#   "code": "c2",
#   "name": "hemoglobin",
#   "description": "test",
#   "totalStock": 10,
#   "currentStock": 0,
#   "consumedStock": 0,
#   "adjustedStock": 0
# }
`

const createInventory = gql`
mutation createInventory(
  	$typeValue: String!
    $code: String!
    $name: String!
    $description: String
    $totalStock: Int
    $currentStock: Int
    $consumedStock: Int
    $adjustedStock: Int
){
  createInventory(input:{
    typeValue: $typeValue
    code: $code
    name: $name
    description: $description
    totalStock: $totalStock
    currentStock: $currentStock
    consumedStock: $consumedStock
    adjustedStock: $adjustedStock
  }){
    id
    typeValue
    code
    name
    description
    totalStock
    currentStock
    consumedStock
    adjustedStock
    createdAt
    updatedAt
    updatedBy
  }
}
# {
#   "typeValue": "global",
#   "code": "c2",
#   "name": "hemoglobin",
#   "description": "ds",
#   "totalStock": 0,
#   "currentStock": 0,
#   "consumedStock": 0,
#   "adjustedStock": 0
# }
`


const createQuestionTemplateActivity = gql`
mutation createQuestionTemplateActivity(
  $typeValue: String!
  $slugValue: String!
  $uId: String!
){
  createQuestionTemplateActivity(input:{
    typeValue:$typeValue,
    slugValue: $slugValue,
    uId: $uId
  }){
    typeValue
    slugValue
    uId
    createdAt
    createdBy
  }
}
`


const createFormTemplateActivity = gql`
mutation createFormTemplateActivity(
  $typeValue: String!
  $slugValue: String!
  $uId: String!
){createFormTemplateActivity(input:{
    typeValue:$typeValue,
    slugValue: $slugValue,
    uId: $uId
  }){
    typeValue
    slugValue
    activityType
    uId
    createdAt
    createdBy
  }
}
`


const deleteFormTemplateActivity = gql`
mutation deleteFormTemplateActivity($slugValue: String! $typeValue: String!){
  deleteFormTemplateActivity(slugValue: $slugValue typeValue: $typeValue)
}
# {
#   "typeValue": "TE00003::template",
#   "slugValue": "form-na"
# }
# {
#   "typeValue": "TE00003::question",
#   "slugValue": "abc"
# }
`

const updateFormSubscriber = gql`
mutation updateFormSubscriber(
  $typeValue: String!
  $email: String!
	$mobile: String
  $countryCode: String
	$contactName: String
	$orgName: String
	$address: AddressInput
	$gstNo: String
	$noOfTemplates: Int
	$expiryDate: Int
	$enabled: Boolean
	$paymentRemark: String
  $callbackUrl: String
  $datasetEnabled: Boolean
){
  updateFormSubscriber(input:{
    typeValue: $typeValue
    email: $email
    mobile: $mobile
    countryCode: $countryCode
    contactName: $contactName
    orgName: $orgName
    address: $address
    gstNo: $gstNo
    noOfTemplates: $noOfTemplates
    expiryDate: $expiryDate
    enabled: $enabled
    paymentRemark: $paymentRemark
    callbackUrl: $callbackUrl
    datasetEnabled: $datasetEnabled
  }){
    typeValue
    email
    mobile
    contactName
    countryCode
    orgName
    gstNo
    noOfTemplates
    expiryDate
    enabled
    createdAt
    updatedAt
    callbackUrl
    datasetEnabled
    address{
      use
      type
      lineOne
      lineTwo
      city
      state
      zip
      country
    }
  }
}
# {
#   "typeValue": "subscriber",
#   "email": "sohel.khan@clinivantage.com",
#   "mobile": "8459832342",
#   "countryCode": "+91",
#   "contactName": "Sohel khan",
#   "orgName": "Recaho",
#   "gstNo": "e3wrwe",
#   "noOfTemplates": 20,
#   "enabled": true,
#   "expiryDate": 1634122088,
#   "address": {
#     "use": "WORK",
#     "type": "BOTH",
#     "lineOne": "test",
#     "city": "pune",
#     "state": "maharashtra",
#     "zip": "411033",
#     "country": "IND"
#   }
# }
`

const createFormSubscriber = gql`
mutation createFormSubscriber(
  $email: String!
	$mobile: String!
	$contactName: String!
  $countryCode: String!
	$orgName: String!
	$address: AddressInput
	$gstNo: String
	$noOfTemplates: Int!
	$expiryDate: Int!
	$enabled: Boolean!
	$paymentRemark: String
  $datasetEnabled: Boolean
){
  createFormSubscriber(input:{
    email: $email
    mobile: $mobile
    contactName: $contactName
    countryCode: $countryCode
    orgName: $orgName
    address: $address
    gstNo: $gstNo
    noOfTemplates: $noOfTemplates
    expiryDate: $expiryDate
    enabled: $enabled
    paymentRemark: $paymentRemark
    datasetEnabled: $datasetEnabled
  }){
    typeValue
    email
    mobile
    contactName
    countryCode
    orgName
    gstNo
    noOfTemplates
    expiryDate
    enabled
    createdAt
    updatedAt
    subscriberId
    apiKey
    callbackUrl
    datasetEnabled
    address{
      use
      type
      lineOne
      lineTwo
      city
      state
      zip
      country
    }
  }
}
# {
#   "email": "sohel.khan@clinivantage.com",
#   "mobile": "8459832342",
#   "countryCode": "+91",
#   "contactName": "Sohel khan",
#   "orgName": "Recaho",
#   "gstNo": "e3wrwe",
#   "noOfTemplates": 10,
#   "enabled": true,
#   "expiryDate": 1634122088,
#   "address": {
#     "use": "WORK",
#     "type": "BOTH",
#     "lineOne": "test",
#     "city": "pune",
#     "state": "maharashtra",
#     "zip": "411033",
#     "country": "IND"
#   }
# }
`;

const createUnitTestConfig = gql`
mutation createUnitTestConfig(
  	$orgId: String!
    $deviceId: String!
    $active: Boolean!
  	$physicalId: String!
    $deployedAt: String
    $deviceType: String!
    $categories: [TestCategoryInput!]
    $assignedDevices: [AssignedDevicesInput!]
    $channelId:String
    $platform: PLATFORM
    $system: ATM_SYSTEM
    $hospitalId:String
){
  createUnitTestConfig(input:{
    orgId: $orgId
    deviceId: $deviceId
    physicalId: $physicalId
    deployedAt: $deployedAt
    active: $active
    deviceType: $deviceType
    categories: $categories
    assignedDevices: $assignedDevices
    channelId:$channelId
    platform:$platform
    system:$system
    hospitalId:$hospitalId
  }){
    orgId
    deviceId
    physicalId
    deployedAt
    active
    deviceType
    channelId
    platform
    system
    hospitalId
    assignedDevices{
      deviceName
      serialNumber
      deviceType
    }
    categories{
      category
      active
      tests{
        text
        value
        rate
        refImage{
          bucket
          region
          key
        }
        url{
          bucket
          region
          key
        }
        enabled
        active
      }
    }
  }
}
`;

const updateUnitTestConfig = gql`
mutation updateUnitTestConfig(
  	$orgId: String!
    $deviceId: String!
    $active: Boolean!
	  $deployedAt: String
  	$physicalId: String!
    $deviceType: String!
    $categories: [TestCategoryInput!]
    $assignedDevices: [AssignedDevicesInput!]
    $channelId:String
    $platform: PLATFORM
    $system: ATM_SYSTEM
    $hospitalId:String
){
  updateUnitTestConfig(input:{
    orgId: $orgId
    deviceId: $deviceId
    physicalId: $physicalId
    deployedAt: $deployedAt
    active: $active
    deviceType: $deviceType
    categories: $categories
    assignedDevices: $assignedDevices
    channelId:$channelId
    platform:$platform
    system:$system
    hospitalId:$hospitalId
  }){
    orgId
    deviceId
    physicalId
    deployedAt
    active
    deviceType
    channelId
    platform
    system
    hospitalId
    assignedDevices{
      deviceName
	    serialNumber
	    deviceType
    }
    categories{
      category
      active
      tests{
        deviceName
        text
        value
        rate
        refImage{
          bucket
          region
          key
        }
        url{
          key
          bucket
          region
        }
        enabled
        active
      }
    }
  }
}

# {
#   "orgId": "clinivantage-healthcare",
#   "deviceId": "123",
#   "active": true,
#   "physicalId": "AS:7S:676",
#   "deployedAt": "clinivantage-healthcare-pune",
#   "deviceType": "ATM",
#   "categories": [
#     {
#       "category": "Physical Test",
#       "active": true,
#       "tests": [
#         {
    
#           "text": "PULSE OXIMETER",
#           "value": "PULSE_OXIMETER",
#           "rate": 160,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "BLOOD PRESSURE",
#           "value": "BLOOD_PRESSURE",
#           "rate": 160,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "WEIGHT",
#           "value": "WEIGHT",
#           "rate": 80,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "HEIGHT",
#           "value": "HEIGHT",
#           "rate": 80,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "TEMPERATURE",
#           "value": "TEMPERATURE",
#           "rate": 120,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "BMI",
#           "value": "BMI",
#           "rate": 120,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "ECG",
#           "value": "ECG",
#           "rate": 120,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Mid-arm circumference",
#           "value": "MID_ARM",
#           "rate": 120,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         }
#       ]
#     },
#     {
#       "category": "Whole Blood POCT",
#       "active": true,
#       "tests": [
#         {
    
#           "text": "Blood Grouping",
#           "value": "BLOOD_GROUPING",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Blood Glucose",
#           "value": "BLOOD_GLUCOSE",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Cholestrol",
#           "value": "CHOLESTEROL",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Hemocue",
#           "value": "HEMOCUE",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Hemoglobin",
#           "value": "HEMOGLOBIN",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Uric Acid",
#           "value": "URIC_ACID",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Lipid Profile",
#           "value": "LIPID_PROFILE",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         }
#       ]
#     },
#      {
#       "category": "Whole Blood RDT",
#       "active": true,
#       "tests": [
#         {
    
#           "text": "Typhoid",
#           "value": "TYPHOID",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Malaria",
#           "value": "MALARIA",
#           "rate": 500,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Hepatits B",
#           "value": "HEPATITIS_B",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Syphilis",
#           "value": "SYPHILIS",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Hepatits C",
#           "value": "HEPATITIS_C",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "HIV",
#           "value": "HIV",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Dengue Antigen",
#           "value": "DENGUE_ANTIGEN",
#           "rate": 180,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Chikungunya",
#           "value": "CHIKUNGUNYA",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Troponin 1",
#           "value": "TROPONIN_1",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "D-Dimer",
#           "value": "D-DIMER",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "CRP",
#           "value": "CRP",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Leptospira",
#           "value": "LEPTOSPIRA",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         }
#       ]
#     },
#     {
#       "category": "Urine Tests",
#       "active": true,
#       "tests": [
#         {
    
#           "text": "Pregnancy",
#           "value": "PREGNANCY",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         },
#         {
    
#           "text": "Urine 2P",
#           "value": "URINE",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         }
#       ]
#     },
#     {
#       "category": "Hematology",
#       "active": true,
#       "tests": [
#         {
    
#           "text": "WBC DIFF",
#           "value": "WBC_DIFF",
#           "rate": 200,
#           "url": "imag link",
#           "enabled": true,
#           "active": true
#         }
#       ]
#     }
#   ]
# }
`;

const updateOrg = gql`
mutation updateOrg(
  $fqdn: String!
  $unitId: ID!
  $orgName: String!
  $email: String!
  $contactNo: String
  $address: AddressInput!
  $isActive: Boolean!
){
  updateOrg(input:{
    fqdn: $fqdn
    unitId: $unitId
    orgName: $orgName
    email: $email
    contactNo: $contactNo
    address: $address
    isActive: $isActive
  }){
    fqdn
    unitId
    orgName
    email
    contactNo
    isActive
    address{
      use
      type
      lineOne
      lineTwo
      city
      state
      zip
      country
    }
  }
}
# {
#   "fqdn": "org::clinivantage.pms.com",
#   "unitId": "clinivantage-healthcare",
#   "orgName": "Clinivantage Healthcare",
#   "email": "admin@clinivantage.com",
#   "contactNo": "+919028887875",
#   "address": {
#     "use": "WORK",
#     "type": "PHYSICAL",
#     "lineOne": "Tulsi Green",
#     "lineTwo": " Laxman Nagar Baner",
#     "city": "Pune",
#     "state": "Maharashtra",
#     "zip": "411045",
#     "country": "IND"
#   },
#   "isActive": true
# }
`


const updateFormAnswer = gql`
mutation updateFormAnswer(
  $patientId: String
  $formId: String
  $doctorId: String
  $formData: [FormDataInput!]
){
  updateFormAnswer(input:{
    patientId: $patientId
    formId: $formId
    doctorId: $doctorId
    formData: $formData
  }){
    patientId
    formId
    doctorId
    createdAt
    updatedAt
    formData{
      queUId
      queTitle
      queType
      ansText
      ansSummary
      ansMap{
        bucket
        region
        key
      }
      ansList{
        ansText
        ansSummary
      }
    }
  }
}
# {
#   "patientId": "suzain::md::male::2006-11-06#1589632678",
#   "formId": "2796741a-c086-40ca-9632-54db1b2849b6",
#   "doctorId": "khan.sohel005@gmail.com",
#   "formData": [
#     {
#       "queUId": "58f38c09-6c4b-4d57-be75-27314cabcc45",
#       "queTitle": "What is your name",
#       "queType": "FREE_TEXT",
#       "ansText": "Suzain",
#       "ansSummary": "self name"
#     },
#     {
#       "queUId": "8190a9df-0223-41cc-88f0-2da68c082c95",
#       "queTitle": "DOB",
#       "queType": "DATE",
#       "ansText": "2006-11-26",
#       "ansSummary": null
#     },
#     {
#       "queUId": "fc718250-63f9-4649-9813-60b6ba1a9696",
#       "queTitle": "Photo",
#       "queType": "FILE",
#       "ansMap": {
#         "bucket": "sdf",
#         "key": "fsd",
#         "region": "fsfd"
#       },
#       "ansSummary": "photo"
#     },
#     {
#       "queUId": "173dcaed-afe9-4cdc-9873-b50feed1fbf0",
#       "queTitle": "Do you have question",
#       "queType": "RADIO_BUTTON",
#       "ansText": "Yes",
#       "ansSummary": "i have que"
#     }
#   ]
# }
`;


const createFormAnswer = gql`
mutation createFormAnswer(
  $patientId: String
  $formId: String
  $doctorId: String
  $formData: [FormDataInput!]
){
  createFormAnswer(input:{
    patientId: $patientId
    formId: $formId
    doctorId: $doctorId
    formData: $formData
  }){
    patientId
    formId
    doctorId
    createdAt
    updatedAt
    formData{
      queUId
      queTitle
      queType
      ansText
      ansSummary
      ansMap{
        bucket
        region
        key
      }
      ansList{
        ansText
        ansSummary
      }
    }
  }
}
# {
#   "patientId": "suzain::md::male::2006-11-06#1589632678",
#   "formId": "2796741a-c086-40ca-9632-54db1b2849b6",
#   "doctorId": "khan.sohel005@gmail.com",
#   "formData": [
#     {
#       "queUId": "58f38c09-6c4b-4d57-be75-27314cabcc45",
#       "queTitle": "What is your name",
#       "queType": "FREE_TEXT",
#       "ansText": "Suzain",
#       "ansSummary": "self name"
#     },
#     {
#       "queUId": "8190a9df-0223-41cc-88f0-2da68c082c95",
#       "queTitle": "DOB",
#       "queType": "DATE",
#       "ansText": "2006-11-26",
#       "ansSummary": null
#     },
#     {
#       "queUId": "fc718250-63f9-4649-9813-60b6ba1a9696",
#       "queTitle": "Photo",
#       "queType": "FILE",
#       "ansMap": {
#         "bucket": "sdf",
#         "key": "fsd",
#         "region": "fsfd"
#       },
#       "ansSummary": "photo"
#     },
#     {
#       "queUId": "173dcaed-afe9-4cdc-9873-b50feed1fbf0",
#       "queTitle": "Do you have question",
#       "queType": "RADIO_BUTTON",
#       "ansText": "Yes",
#       "ansSummary": "i have que"
#     }
#   ]
# }
`;



const deleteSectionTemplate = gql`
mutation deleteSectionTemplate($typeValue: String! $slugValue: String!){
  deleteSectionTemplate(typeValue: $typeValue slugValue: $slugValue){
    typeValue
    slugValue
    sectionName
    
  }
}
# {
#   "typeValue": "global::section",
#   "slugValue": "my-section-2"
# }
`;



const deleteFormTemplate = gql`
mutation deleteFormTemplate($typeValue: String! $slugValue: String!){
  deleteFormTemplate(typeValue: $typeValue slugValue: $slugValue){
    typeValue
    slugValue
    templateName
    displayName
    templateType
  }
}
# {
#   "typeValue": "global::template",
#   "slugValue": "my-form-1"
# }
`;


const updateFormTemplate = gql`
mutation updateFormTemplate(
  $typeValue: String!
	$slugValue: String!
	$templateName: String!
  $displayName: String
	$templateType: String
	$subTemplate: String
	$speciality: String
	$subSpeciality: String
	$questionRefs: [String!]
	$templateRows: [TemplateRowsInput] 
  $templateDesignJson: AWSJSON
	$active: Boolean
  $keywords: [String!]
  $customVariables: AWSJSON
){
  updateFormTemplate(input:{
    typeValue: $typeValue
    slugValue: $slugValue
    templateName: $templateName
    displayName: $displayName
    templateType: $templateType
    subTemplate: $subTemplate
    speciality: $speciality
    subSpeciality: $subSpeciality
    questionRefs: $questionRefs
    templateRows: $templateRows
    templateDesignJson: $templateDesignJson
    active: $active
    keywords: $keywords
    customVariables: $customVariables
  }){
    # id
    uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      attachedSubtemplateRef{
          # id
      uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    displayName
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      # uId
      attachedQuestionRefs {
        # id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
      }
      }
      # uId
      attachedQuestionRefs {
        id
        typeValue
        slugValue
        questionTitle
        questionType
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
  }
}
# {
#   "typeValue": "global::template",
#   "slugValue": "my-form",
#   "templateName": "My Form",
#   "templateType": "Physical Examination",
#   "subTemplate": null,
#   "sectionRefs": ["global::section#my-section","global::section#my-section-1"],
#   "active": true
# }
`;


const updateSectionTemplate = gql`
mutation updateSectionTemplate(
  $typeValue: String!
  $slugValue: String!
  $sectionName: String!
  $questionRefs: [String!]!
  $active: Boolean
){
  updateSectionTemplate(input:{
    typeValue: $typeValue
    slugValue: $slugValue
    sectionName: $sectionName
    questionRefs: $questionRefs
    active: $active
  }){
    typeValue
    slugValue
    sectionName
    questionRefs
    active
    createdAt
    updatedAt
  }
}
# {
#   "typeValue": "global::section",
#   "slugValue": "my-section",
#   "sectionName": "My Section",
#   "questionRefs": ["global::question#do-you-have-question","global::question#photo"],
#   "active": true
# }
`


const deleteQuestionTemplate = gql`
mutation deleteQuestionTemplate( $typeValue: String! $slugValue: String!){
  deleteQuestionTemplate(typeValue: $typeValue slugValue: $slugValue){
    typeValue
    slugValue
    questionTitle
    questionType
    uId
  }
}
# {
#   "typeValue": "global::question",
#   "slugValue": "dob"
# }
`;


const updateQuestionTemplate = gql`
mutation updateQuestionTemplate(
  $typeValue: String!
  $slugValue: String!
  $questionTitle: String!
  $questionType: QUESTION_TYPE!
  $freeText: FreeTextInput
  $helpText: String
  $number: NumberInput
  $date: DateInput
  $file: FileInput
  $radioList: [RadioListInput!]
  $checkboxList: [CheckboxListInput!]
  $fillInBlanks: FillInBlanksInput
  $ageFrom: Int
  $ageTo: Int
  $appliedFor: Gender_For
  $active: Boolean
  $refImage: RefImageInput
  $isRequired: Boolean
  $tableValues: AWSJSON
  $radioDisplayType: String
  $addNote: Boolean    
  $addNotApplicable: Boolean
   $addPainCalculation: Boolean
   $allowToPrint: Boolean     
   $selectedPainQue: String
){
  updateQuestionTemplate(input:{
    typeValue: $typeValue
    slugValue: $slugValue
    questionTitle: $questionTitle
    questionType: $questionType
    freeText: $freeText
    helpText: $helpText
    number: $number
    date: $date
    file: $file
    radioList: $radioList
    checkboxList: $checkboxList
    fillInBlanks: $fillInBlanks
    ageFrom: $ageFrom
    ageTo: $ageTo
    appliedFor: $appliedFor
    active: $active
    refImage: $refImage
    isRequired: $isRequired
    tableValues: $tableValues
    radioDisplayType: $radioDisplayType 
     addNote: $addNote  
     addNotApplicable: $addNotApplicable
     addPainCalculation: $addPainCalculation
     allowToPrint: $allowToPrint
     selectedPainQue: $selectedPainQue
  }){
    typeValue
        slugValue
        questionTitle
        questionType
        uId
        ageFrom
        ageTo
        addNote 
        addNotApplicable 
        addPainCalculation
        allowToPrint
        selectedPainQue
        appliedFor
        createdAt
        helpText
        updatedAt
        active
        isRequired
        searchField
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType 
      
  }
}
# {
#   "typeValue": "global::question",
#   "slugValue": "what-is-your-name",
#   "questionTitle": "What is your name",
#   "questionType": "FREE_TEXT",
#   "freeText": {
#     "answerSummary": "summary 1",
#     "freeTextRequired": false
#   },
#   "ageFrom": 15,
#   "ageTo": 60,
#   "appliedFor": "MALE"
#   "isRequired": false
# }
# {
#   "typeValue": "global::question",
#   "slugValue": "do-you-have-question",
#   "questionTitle": "Do you have question",
#   "questionType": "RADIO_BUTTON",
# 	"radioList": [
#     {
#       "optionTitle": "Yes",
#       "optionSummary": "yes summary",
#       "freeTextRequired": false
#     },
#     {
#       "optionTitle": "no",
#       "optionSummary": "no summary",
#       "freeTextRequired": false
#     },
#     {
#       "optionTitle": "may be",
#       "optionSummary": "may be summary",
#       "freeTextRequired": false
#     }
#   ],
#   "ageFrom": 10,
#   "ageTo": 70,
#   "appliedFor": "BOTH"
#   "isRequired": false
# }
`;




const createFormTemplate = gql`
mutation createFormTemplate(
  $typeValue: String!
  $slugValue: String!
  $templateName: String!
  $displayName: String
  $templateType: String
  $subTemplate: String
  $speciality: String
	$subSpeciality: String
	$questionRefs: [String!]
	$templateRows: [TemplateRowsInput] 
  $templateDesignJson: AWSJSON
  $keywords: [String!]
  $customVariables: AWSJSON
){
  createFormTemplate(input:{
    typeValue: $typeValue
    slugValue: $slugValue
    templateName: $templateName
    displayName: $displayName
    templateType: $templateType
    subTemplate: $subTemplate
    speciality: $speciality
    subSpeciality: $subSpeciality
    questionRefs: $questionRefs
    templateRows: $templateRows 
    templateDesignJson: $templateDesignJson
    keywords: $keywords
    customVariables: $customVariables
  }){
    # id
    uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      attachedSubtemplateRef{
          # id
      uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    displayName
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      # uId
      attachedQuestionRefs {
        # id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
      }
      }
      # uId
      attachedQuestionRefs {
        id
        typeValue
        slugValue
        questionTitle
        questionType
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
  }
}
# {
#   "typeValue": "global::template",
#   "slugValue": "test-complaint",
#   "templateName": "Test Complaint",
#   "templateType": "Complaint",
#   "subTemplate": "Fever",
#   "sectionRefs": ["global::section#my-section-2"]
# }
# {
#   "typeValue": "global::template",
#   "slugValue": "test-complaint",
#   "templateName": "Test Complaint",
#   "templateType": "Complaint",
#   "subTemplate": "Fever",
#   "sectionRefs": ["global::section#my-section-2"]
# }
`;

const createSectionTemplate = gql`
mutation createSectionTemplate(
  $typeValue: String!
  $slugValue: String!
  $sectionName: String!
  $questionRefs: [String!]!
){
  createSectionTemplate(input:{
    typeValue: $typeValue
    slugValue: $slugValue
    sectionName: $sectionName
    questionRefs: $questionRefs
  }){
    typeValue
    slugValue
    sectionName
    questionRefs
    active
    createdAt
    updatedAt
  }
}
# {
#   "typeValue": "global::section",
#   "slugValue": "my-section",
#   "sectionName": "My Section",
#   "questionRefs": ["global::question#do-you-have-question"]
# }
`

const createQuestionTemplate = gql`
mutation createQuestionTemplate(
  $typeValue: String!
  $slugValue: String!
  $questionTitle: String!
  $helpText: String
  $questionType: QUESTION_TYPE!
  $freeText: FreeTextInput
  $number: NumberInput
  $date: DateInput
  $file: FileInput
  $radioList: [RadioListInput!]
  $checkboxList: [CheckboxListInput!]
  $fillInBlanks: FillInBlanksInput
  $ageFrom: Int
  $ageTo: Int 
  $addNote: Boolean
  $addNotApplicable: Boolean
  $addPainCalculation: Boolean
  $allowToPrint: Boolean
  $selectedPainQue: String
  $appliedFor: Gender_For
  $refImage: RefImageInput
  $tableValues: AWSJSON
  $isRequired: Boolean
  $radioDisplayType: String
){
  createQuestionTemplate(input:{
    typeValue: $typeValue
    slugValue: $slugValue
    questionTitle: $questionTitle
    helpText: $helpText
    questionType: $questionType
    freeText: $freeText
    number: $number
    date: $date
    file: $file
    radioList: $radioList
    checkboxList: $checkboxList
    fillInBlanks: $fillInBlanks
    ageFrom: $ageFrom
    ageTo: $ageTo
     addNote: $addNote
    addNotApplicable: $addNotApplicable
    addPainCalculation: $addPainCalculation
    allowToPrint: $allowToPrint
    selectedPainQue: $selectedPainQue
    appliedFor: $appliedFor
    refImage: $refImage
    tableValues: $tableValues
    isRequired: $isRequired
    radioDisplayType: $radioDisplayType
  }){
    typeValue
        slugValue
        questionTitle
        questionType
        uId
        ageFrom
        ageTo
        addNote
        addNotApplicable
        addPainCalculation
        allowToPrint
        selectedPainQue
        appliedFor
        helpText
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        searchField
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
  }
}
# {
#   "typeValue": "global::question",
#   "slugValue": "what-is-your-name",
#   "questionTitle": "What is your name",
#   "questionType": "FREE_TEXT",
#   "freeText": {
#     "answerSummary": "summary1",
#     "freeTextRequired": false
#   },
#   "ageFrom": 5,
#   "ageTo": 60,
#   "appliedFor": "MALE"
# }
# {
#   "typeValue": "global::question",
#   "slugValue": "dob",
#   "questionTitle": "DOB",
#   "questionType": "DATE",
#   "date": {
#     "answerSummary": "2012-12-15",
#     "freeTextRequired": false
#   },
#   "ageFrom": 5,
#   "ageTo": 60,
#   "appliedFor": "BOTH"
# }
# {
#   "typeValue": "global::question",
#   "slugValue": "photo",
#   "questionTitle": "Photo",
#   "questionType": "FILE",
#   "file": {
#     "answerSummary": "fileSummary",
#     "freeTextRequired": false
#   },
#   "ageFrom": 5,
#   "ageTo": 60,
#   "appliedFor": "MALE"
# }
# {
#   "typeValue": "global::question",
#   "slugValue": "do-you-have-question",
#   "questionTitle": "Do you have question",
#   "questionType": "RADIO_BUTTON",
# 	"radioList": [
#     {
#       "optionTitle": "yes",
#       "optionSummary": "yes summary",
#       "freeTextRequired": false
#     },
#     {
#       "optionTitle": "no",
#       "optionSummary": "no summary",
#       "freeTextRequired": false
#     },
#     {
#       "optionTitle": "may be",
#       "optionSummary": "may be summary",
#       "freeTextRequired": false
#     }
#   ],
#   "ageFrom": 10,
#   "ageTo": 70,
#   "appliedFor": "BOTH"
# }
# {
#   "typeValue": "global::question",
#   "slugValue": "select-symptoms",
#   "questionTitle": "Select symptoms",
#   "questionType": "CHECK_BOX",
# 	"checkboxList": [
#     {
#       "optionTitle": "fever",
#       "optionSummary": "fever summary",
#       "freeTextRequired": false
#     },
#     {
#       "optionTitle": "headache",
#       "optionSummary": "headache summary",
#       "freeTextRequired": false
#     },
#     {
#       "optionTitle": "acidity",
#       "optionSummary": "acidity be summary",
#       "freeTextRequired": false
#     }
#   ],
#   "ageFrom": 10,
#   "ageTo": 70,
#   "appliedFor": "BOTH"
# }
`;




const createUnit = gql`
mutation createUnit(
  $input:CreateUnitInput!
){
  createUnit(input: $input){
    fqdn
    unitName
    orgId
    email
    contactNo
    pharmacyLicenseNo
    clinicRegiNo
    shopEstNo
    tradeNo
    isActive
    createdAt
    updatedAt
    skypeId
    address{
      use
      type
      lineOne
      lineTwo
      city
      state
      zip
      country
    }
    logo{
      bucket
      region
      key
    }
  }
}
# {
#   "unitName": "Clinivantage Healthcare Mumbai",
#   "email": "cvmumbai@clinivantage.com",
#   "contactNo": "+919028772221",
#   "pharmacyLicenseNo": "24543",
#   "clinicRegiNo": "6576",
#   "shopEstNo": "42437654567",
#   "tradeNo": "7657",
#   "isActive": true,
#   "address": {
#     "use": "WORK",
#     "type": "PHYSICAL",
#     "lineOne": "63, BMC Industrial Estate",
#     "lineTwo": " Worli",
#     "city": "Mumbai",
#     "state": "Maharashtra",
#     "zip": "400013",
#     "country": "IND"
#   }
# }
`


const createOrg = gql`
mutation createOrg(
  $fqdn: String!
  $unitId: ID!
  $orgName: String!
  $email: String!
  $contactNo: String
  $address: AddressInput!
  $isActive: Boolean!
){
  createOrg(input:{
    fqdn: $fqdn
    unitId: $unitId
    orgName: $orgName
    email: $email
    contactNo: $contactNo
    address: $address
    isActive: $isActive
  }){
    fqdn
    unitId
    orgName
    email
    contactNo
    type
    isActive
    address{
      use
      type
      lineOne
      lineTwo
      city
      state
      zip
      country
    }
  }
}
# {
#   "fqdn": "clinivantage.pms.com",
#   "unitId": "clinivantage-healthcare",
#   "orgName": "Clinivantage Healthcare",
#   "email": "admin@clinivantage.com",
#   "contactNo": "+918459832342",
#   "address": {
#     "use": "WORK",
#     "type": "PHYSICAL",
#     "lineOne": "Tulsi Green",
#     "lineTwo": " Laxman Nagar Baner",
#     "city": "Pune",
#     "state": "Maharashtra",
#     "zip": "411045",
#     "country": "IND"
#   },
#   "isActive": true
# }
`


const updateUnit = gql`
mutation updateUnit(
  $fqdn: String!
  $unitId: String!
  $unitName: String!
  $email: String!
  $contactNo: String!
  $address: AddressInput!
  $pharmacyLicenseNo: String
  $clinicRegiNo: String
  $shopEstNo: String
  $tradeNo: String
  $isActive: Boolean!
  $skypeId:String
  $logo: S3ObjectInput
){
  updateUnit(input:{
    fqdn: $fqdn
    unitId: $unitId
    unitName: $unitName
    email: $email
    contactNo: $contactNo
    address: $address
    pharmacyLicenseNo: $pharmacyLicenseNo
    clinicRegiNo: $clinicRegiNo
    shopEstNo: $shopEstNo
    tradeNo: $tradeNo
    isActive: $isActive
    skypeId: $skypeId
    logo: $logo
  }){
    fqdn
    unitName
    orgId
    email
    contactNo
    pharmacyLicenseNo
    clinicRegiNo
    shopEstNo
    tradeNo
    isActive
    createdAt
    updatedAt
    skypeId
  }
}
# {
#   "fqdn": "unit::clinivantage.pms.com",
#   "unitId": "clinivantage-healthcare-baner",
#   "unitName": "Clinivantage Healthcare Baner",
#   "email": "cvbaner@clinivantage.com",
#   "contactNo": "+919028772221",
#   "pharmacyLicenseNo": "1111111111111",
#   "clinicRegiNo": "434343",
#   "shopEstNo": "42434567",
#   "tradeNo": "675754",
#   "isActive": true,
#   "address": {
#     "use": "WORK",
#     "type": "PHYSICAL",
#     "lineOne": "Tulsi Green",
#     "lineTwo": " Laxman Nagar Baner",
#     "city": "Pune",
#     "state": "Maharashtra",
#     "zip": "411045",
#     "country": "IND"
#   }
# }
`;

const createStaff = gql`
mutation createStaff(
  $prefix: String
  $fName: String!
  $mName: String
  $lName: String!
  $gender: Gender
  $email: String!
  $countryCode: String!
  $mobile: String!
  $dob: String!
  $maritalStatus: maritalStatus
  $userRole: String!
  $roleType: String
  $active: Boolean
  $isDoctor: Boolean
  $skypeId: String
  $photo: S3ObjectInput
  $address: AddressInput
){
  createStaff(input:{
    prefix: $prefix
    fName: $fName
    mName: $mName
    lName: $lName
    gender: $gender
    email: $email
    countryCode: $countryCode
    mobile: $mobile
    dob: $dob
    maritalStatus: $maritalStatus
    userRole: $userRole
    roleType: $roleType
    active: $active
    isDoctor: $isDoctor
    skypeId: $skypeId
    photo: $photo
    address: $address
  }){
    fName
    mName
    lName
    email
    mobile
    countryCode
    dob
    gender
    maritalStatus
    userRole
    roleType
    active
    isDoctor
    skypeId
    createdAt
    address{
      use
      type
      lineOne
      lineTwo
      city
      state
      zip
      country
    }
    photo{
      bucket
      region
      key
    }
  }
}
`;
